import { useRef } from "react";

// Boutons subtilement attirés par le curseur (sans framer-motion)
export default function Magnetic({ children, strength = 0.3, className = "" }) {
  const ref = useRef(null);
  const onMove = (e) => {
    const node = ref.current;
    if (!node) return;
    const r = node.getBoundingClientRect();
    const x = (e.clientX - r.left - r.width / 2) * strength;
    const y = (e.clientY - r.top - r.height / 2) * strength;
    node.style.transform = `translate(${x}px, ${y}px)`;
  };
  const reset = () => {
    if (ref.current) ref.current.style.transform = "translate(0px, 0px)";
  };
  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      style={{ transition: "transform 0.35s cubic-bezier(0.22, 1, 0.36, 1)", willChange: "transform" }}
      className={`inline-block ${className}`}
    >
      {children}
    </div>
  );
}
